<template>
    <div class="certain-category-search-wrapper">
        <a-auto-complete dropdown-class-name="certain-category-search-dropdown" :dropdown-match-select-width="false"
            :dropdown-style="{ width: '300px' }" size="large" style="width: 100%" placeholder="input here"
            option-label-prop="aweme_id">
            <template slot="dataSource">
                <a-select-opt-group>
                    <span slot="label" class="aweme-top">
                        请选择
                        <a style="float: right;color: #194ce5;" href="javascript:void(0);" @click="goaccout()"> +
                            新增授权
                        </a>
                    </span>
                    <a-select-option v-for="opt in dataSource" :key="opt.title" :value="opt.aweme_id">
                        <div class="select-aweme" @click="changAweme(opt)">
                            <img :src="opt.aweme_avatar" alt="avatar" class="aweme-avatar" v-if="opt.aweme_avatar"/>
                            <div class="aweme-right">
                                <div class="aweme-info">
                                    <div class="aweme-name">{{ opt.aweme_name }}</div>
                                    <div class=" official" v-if="opt.general_balance_valid">
                                        余额：{{opt.general_balance_valid||'-'}}
                                    </div>
                                </div>
                                <div class="aweme-show-id" v-if="opt.advertiser_id">户ID：{{ opt.advertiser_id }}</div>
                            </div>
                        </div>
                    </a-select-option>
                </a-select-opt-group>
            </template>
            <div class="aweme_list">
                <img :src="selectRes.aweme_avatar || dataSource[0].aweme_avatar"  v-if="selectRes.aweme_avatar || dataSource[0].aweme_avatar" alt="avatar" class="account-avatar">
                <div class="account-name">{{ selectRes.aweme_name || dataSource[0].aweme_name }} <span v-if="selectRes.general_balance_valid || dataSource[0].general_balance_valid">(余额：{{selectRes.general_balance_valid || dataSource[0].general_balance_valid}})</span></div>
                <div class="auth-type-tag"> 官方 </div>
                <a-icon type="down" class="down" />
            </div>
        </a-auto-complete>
    </div>
</template>

<script>
import { qcApi, requestHttp } from '@utils/index';
export default {
    name: 'awemeList',
    props: {
        dataSource: {
            type: Array,
        },
        action: {
            type: String,
            default: '',
        },
        advertiser_id: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            selectRes: {
                aweme_avatar: '',
                aweme_name: '',
            },
        };
    },

    components: {},

    watch: {},

    mounted() {
        console.log('抖音号子组件接收到的户ID', this.advertiser_id)
        console.log('222', this.action)
        console.log('222', this.dataSource[0])
        if(this.action == 'getVideoId'){
            this.getVideoData(this.dataSource[0]);
        }
        let advertiser_id = this.advertiser_id
         
        if(advertiser_id){
            // if(localStorage.getItem('sxt_advertiser_id')){
            //     advertiser_id = localStorage.getItem('sxt_advertiser_id')
            // }
            console.log('最后子组件接收到的',advertiser_id) 
            let selectRes = this.dataSource.filter(function(item){
                return advertiser_id == item.advertiser_id
            })
            this.selectRes.aweme_avatar = selectRes[0].aweme_avatar
            this.selectRes.aweme_name = selectRes[0].aweme_name
            this.selectRes.general_balance_valid = selectRes[0].general_balance_valid
            console.log('过滤后的',this.selectRes)
        }
    },
    methods: {  

        goaccout(){ 
            this.$router.replace('/sxt_account');
        },
        changAweme(e) {
            console.log('投放号切换',e)
            this.selectRes = e
            this.$emit('getAdvertiserId',e.advertiser_id) 
        }
    },
};
</script>

<style lang="less" scoped>
.certain-category-search-wrapper {
    width: 350px;
}
.aweme_list {
    position: relative;
    width: 350px;
    height: 33px;
    display: flex;
    background-color: #f4f4f4;
    border-radius: 4px;
    align-items: center;
    padding-right: 26px;
    padding-left: 12px;
    cursor: pointer;
    border: 1px solid #ececec;
    .account-avatar {
        margin-right: 8px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }

    .account-name {
        overflow: hidden;
        flex: 1;
        font-size: 15px;
        margin-right: 8px;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
        margin-left: 5px; 
    }

    .auth-type-tag {
        color: #194ce5;
        background: #edf1fd;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 16px;
        height: 16px;
        font-size: 12px;
        padding: 0 4px;
        border-radius: 2px;
        font-weight: normal;
    }

    .down {
        position: absolute;
        top: 50%;
        right: 6px;
        margin-top: -7px;

    }
}

.select-aweme {
    cursor: pointer;
    border-radius: 4px;
    padding: 16px 8px;
    display: flex;
    align-items: center;

    .aweme-avatar {
        display: block;
        height: 32px;
        width: 32px;
        margin-right: 8px;
        border-radius: 50%;
    }

    .aweme-right {
        flex: 1;
    }
}


.aweme-name {
    flex: 1;
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    margin-right: 8px;
    width: 145px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
}

.aweme-info {
    position: relative;
}

.official {
    position: absolute;
    color: #fa0909;
    background: #edf1fd;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 16px;
    height: 16px;
    font-size: 12px;
    padding: 0 4px;
    border-radius: 2px;
    font-weight: normal;
    right: 0px;
    top: 3px;
}

.aweme-show-id {
    font-family: PingFang SC;
    font-size: 12px;
    line-height: 16px;
    height: 16px;
    color: #666;
}
</style>